import { format, isSameDay, isThisYear, isToday } from 'date-fns';
import { ru } from 'date-fns/locale';
import { MessageStatus, UserType } from "../../../../../shared/api";
import { AssistantCodeName } from "../../../../../shared/config";
import { MessagePropStage } from "../../../../../entities/message/types";

// TODO: Сделать правильно определение статуса, после того как подготовим бек
export var getMessageStage = function getMessageStage(params) {
  var message = params.message,
    unreadedMessages = params.unreadedMessages;
  if (message.messageStatus === MessageStatus.failed) {
    return MessagePropStage.REJECTED;
  }
  if (unreadedMessages !== null && unreadedMessages !== void 0 && unreadedMessages.find(function (_ref) {
    var messageId = _ref.messageId;
    return messageId === message.messageId;
  })) {
    return MessagePropStage.SUBMITED;
  }
  if (message.messageStatus === MessageStatus.sent) {
    return MessagePropStage.PENDING;
  }
  return MessagePropStage.UNKNOWN;
};
export var getDateDividerVisible = function getDateDividerVisible(message, previousMessage, isFirst, previousSessionEndTime) {
  if (isFirst && !previousSessionEndTime) {
    return true;
  }
  var currentMessageDate = new Date(message.date);
  if (previousMessage) {
    return !isSameDay(currentMessageDate, new Date(previousMessage));
  }
  return false;
};
export var formatDate = function formatDate(timestamp) {
  var date = new Date(timestamp);
  if (isToday(date)) {
    return 'Сегодня';
  }
  if (isThisYear(date)) {
    return format(date, 'd MMMM', {
      locale: ru
    });
  }
  return format(date, 'd MMMM yyyy', {
    locale: ru
  });
};
var convertAnimalDataToAuthor = function convertAnimalDataToAuthor(animalData) {
  return {
    id: animalData.animalID,
    name: animalData.animalName,
    image: animalData.link,
    type: animalData.animalID
  };
};
var defaultUser = {
  animalID: 1,
  codeName: AssistantCodeName.bee,
  animalName: 'Базя',
  serviceSoc: 'POWER4',
  link: 'https://static.beeline.ru/upload/images/chat/avatar_bee.png'
};
export var getAnimalData = function getAnimalData(author, animalData) {
  var _animalData$find;
  if ((author.type === UserType.Operator || author.type === UserType.External) && author.name) {
    return author;
  }
  return convertAnimalDataToAuthor((_animalData$find = animalData === null || animalData === void 0 ? void 0 : animalData.find(function (el) {
    return el.animalID === author.type;
  })) !== null && _animalData$find !== void 0 ? _animalData$find : defaultUser);
};
export var findReplyedMessage = function findReplyedMessage(sessions, animalData, replyId) {
  if (!replyId) {
    return undefined;
  }
  for (var i = 0; i < sessions.length; i += 1) {
    var messages = sessions[i].messages;
    var replyedMessage = messages.find(function (el) {
      return el.messageId === replyId;
    });
    if (replyedMessage) {
      return {
        message: replyedMessage,
        author: getAnimalData(replyedMessage.author, animalData)
      };
    }
  }
  return undefined;
};
export var isAuthorsDifferent = function isAuthorsDifferent(message, nextMessage) {
  if ((nextMessage === null || nextMessage === void 0 ? void 0 : nextMessage.author.type) !== (message === null || message === void 0 ? void 0 : message.author.type)) {
    return true;
  }
  return (nextMessage === null || nextMessage === void 0 ? void 0 : nextMessage.author.name) !== (message === null || message === void 0 ? void 0 : message.author.name);
};